import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Profile from "@/pages/Profile";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Program from "@/pages/Program";
import History from "@/pages/History";

function App() {
  return (
    <div className="App min-h-screen bg-[#222222]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/assessment/:step" element={<Assessment />} />
          <Route path="/results/:assessmentId" element={<Results />} />
          <Route path="/program/:assessmentId" element={<Program />} />
          <Route path="/history" element={<History />} />

          {/* Russian version */}
          <Route path="/ru" element={<Landing />} />
          <Route path="/ru/profile" element={<Profile />} />
          <Route path="/ru/assessment/:step" element={<Assessment />} />
          <Route path="/ru/results/:assessmentId" element={<Results />} />
          <Route path="/ru/program/:assessmentId" element={<Program />} />
          <Route path="/ru/history" element={<History />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
